import React, {memo, useCallback, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {useHistory} from 'react-router-dom';
import {SettingInputComponent} from '../../../../components/Settings/SettingInputComponent';
import {useKeyboard} from '../../../../hooks/keyboard';
import {useMessage} from '../../../../hooks/message';
import {SettingSelectComponent} from '../../../../components/Settings/SettingSelectComponent';
import {SelectItem} from '../../../../components/Select';
import {useRPC} from '../../../../hooks/rpc';
import {SettingReadOnlyRowComponent} from '../../../../components/Settings/SettingReadOnlyRowComponent';
import {useSelector} from 'react-redux';

const BACK_URL = '/settings';

const MACHINE_OPTIONS: SelectItem<boolean>[] = [
    {
        label: 'Bu Makine',
        value: true,
    },
    {
        label: 'Başka Makine',
        value: false,
    },
];

export const ServerSettingsScreen = memo(function ServerSettingsScreen() {
    const history = useHistory();
    const {success, failure} = useMessage();
    const [rpc] = useRPC();
    const [setActiveInput, renderKeyboard, currentInput] = useKeyboard();

    const connectionAddress = useSelector(state => state.settings.panel.supervisor_connection_address);
    const connectedItem = useMemo(() => {
        if (/localhost/.test(connectionAddress) || /127\.0\.0\.1/.test(connectionAddress)) {
            return MACHINE_OPTIONS.find(a => a.value).label;
        } else {
            return connectionAddress;
        }
    }, [connectionAddress]);

    const [connectToLocalhost, setConnectToLocalhost] = useState<SelectItem<boolean>>(null);
    const [address, setAddress] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const onBackPressed = useCallback(() => {
        history.push(BACK_URL);
    }, [history]);

    const isFieldsValid = useCallback((): boolean => {
        if (connectToLocalhost == null) {
            failure('Lütfen bağlanılacak makine seçiniz.');

            return false;
        }

        if (!connectToLocalhost.value) {
            if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(address) !== true) {
                failure('Lütfen geçerli bir adres ip giriniz.');

                return false;
            }

            if (username == null || username.length === 0) {
                failure('Lütfen kullanıcı adı giriniz.');

                return false;
            }

            if (password == null || password.length === 0) {
                failure('Lütfen şifre giriniz.');

                return false;
            }
        }

        return true;
    }, [address, failure, username, password, connectToLocalhost]);

    const onConnectClick = useCallback(() => {
        if (!isFieldsValid()) {
            return;
        }

        (connectToLocalhost.value ? rpc.connectToLocalMachine() : rpc.connectToMachine(address, username, password))
            .then(() => {
                success('İşlem gerçekleştiriliyor...');
            })
            .catch(failure);
    }, [isFieldsValid, connectToLocalhost?.value, success, rpc, address, username, password, failure]);

    const buttons = useMemo(() => [
        {
            text: 'İPTAL',
            className: 'red',
            onClick: onBackPressed,
        },
        {
            text: 'BAĞLAN',
            onClick: onConnectClick,
            className: 'green',
        },
    ], [onConnectClick, onBackPressed]);

    const onBlur = useCallback(() => {
        setActiveInput(null);
    }, [setActiveInput]);

    return (
        <PasswordContainer
            requiredRole='service'
            isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                className='service-edit'
                backUrl={BACK_URL}
                currentInput={currentInput}>
                <div className='content-divider'>
                    <div className='content-wrapper'>
                        <SettingReadOnlyRowComponent
                            title='Bağlı Olduğu Makine'
                            value={connectedItem}/>
                        <SettingSelectComponent
                            label='Bağlanılacak Makine'
                            options={MACHINE_OPTIONS}
                            onChange={setConnectToLocalhost}
                            value={connectToLocalhost}/>
                        {
                            renderIf(connectToLocalhost?.value === false)(() =>
                                <>
                                    <SettingInputComponent
                                        placeholder='Adres yazınız...'
                                        label='Adres'
                                        value={address}
                                        setValue={setAddress}
                                        setActiveInput={setActiveInput}
                                        onBlur={onBlur}/>
                                    <SettingInputComponent
                                        placeholder='Kullanıcı adı yazınız...'
                                        label='Kullanıcı Adı'
                                        value={username}
                                        setValue={setUsername}
                                        setActiveInput={setActiveInput}
                                        onBlur={onBlur}/>
                                    <SettingInputComponent
                                        type='password'
                                        placeholder='Şifre yazınız...'
                                        label='Şifre'
                                        value={password}
                                        setValue={setPassword}
                                        setActiveInput={setActiveInput}
                                        onBlur={onBlur}/>
                                </>,
                            )
                        }
                    </div>
                    <div className='content-wrapper'>

                    </div>
                </div>
            </SettingsPageContainer>
            {
                renderKeyboard()
            }
        </PasswordContainer>
    );
});
